module.exports = __webpack_public_path__ + "img/ic_target@3x.6f8492c8.png";